import { render, staticRenderFns } from "./CustomerDetailsView.vue?vue&type=template&id=abf8ef98&scoped=true"
import script from "./CustomerDetailsView.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf8ef98",
  null
  
)

export default component.exports